var map = {
	"./global/pc-footer.vue": "9268",
	"./global/pc-header.vue": "e32e",
	"./global/pc-menu.vue": "422b",
	"./global/pc-right-bar.vue": "956b",
	"./global/pc-slides.vue": "8bf8",
	"./pc-carousel.vue": "83a3",
	"./pc-editor.vue": "fe0c",
	"./pc-floor-left-and-right.vue": "63d9",
	"./pc-floor.vue": "a46a",
	"./pc-goods-card.vue": "2509",
	"./pc-hot-goods.vue": "205b",
	"./pc-images.vue": "64b8",
	"./pc-news-card.vue": "8e0a",
	"./pc-separator.vue": "24bc",
	"./pc-space.vue": "acd0",
	"./pc-title.vue": "8fde",
	"./pc-top-floor.vue": "d30f",
	"./pc-video.vue": "ea0d",
	"./quick-nav.vue": "ce6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b5d";